<div class="field col-12">
    <label>{{pergunta.detalhesTitulo}}</label>
    <p-inputNumber [(ngModel)]="pergunta.resposta" [disabled]="!habilitado" (ngModelChange)="respostaAlterada()">
    </p-inputNumber>
</div>